import {css} from 'lit'; export default css`.update{--goto-icon-color:var(--goto-icon-color-default);display:inline-block;margin-left:var(--goto-spacing-00);margin-right:var(--goto-spacing-02);vertical-align:middle}`;
    